(function () {
  var root = document.getElementById('ml-all-reviews');
  if (!root) return;
  var KEY = root.getAttribute('data-kb-client');
  var BID = root.getAttribute('data-kb-business');
  if (!KEY || !BID) return;

  var PMAP = {};
  try { PMAP = JSON.parse(document.getElementById('mlarProducts').textContent); } catch (e) {}

  var grid = root.querySelector('[data-grid]');
  var moreBtn = root.querySelector('[data-more]');
  var statusEl = root.querySelector('[data-status]');
  var summaryEl = root.querySelector('[data-summary]');
  var tabs = root.querySelectorAll('[data-tab]');

  var all = [], seen = {}, view = [], shown = 0, PAGE = 24, filter = 'all';

  function api(params) {
    var u = new URL('https://api.kudobuzz.com/v1/reviews');
    u.searchParams.set('client_id', KEY);
    u.searchParams.set('business_id', BID);
    u.searchParams.set('state', 'published');
    u.searchParams.set('limit', '100');
    Object.keys(params || {}).forEach(function (k) { u.searchParams.set(k, params[k]); });
    return fetch(u.toString())
      .then(function (r) { return r.ok ? r.json() : { data: [] }; })
      .then(function (j) { return j.data || []; })
      .catch(function () { return []; });
  }

  function text(r) { return r && r.message ? String(r.message).trim() : ''; }

  function usable(r) {
    if (!r || !r.id) return false;
    if (r.state && r.state.type && r.state.type !== 'published') return false;
    var m = text(r);
    if (!m) return false;
    if (/^rated\s+\d\s+stars?/i.test(m)) return false;
    return true;
  }

  function dupeKey(r) {
    var who = ((r.reviewer && r.reviewer.display_name) || '').trim().toLowerCase();
    return 'k:' + who + '|' + text(r).toLowerCase().replace(/\s+/g, ' ');
  }

  function add(list) {
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!usable(r)) continue;
      var k = dupeKey(r);
      if (seen[r.id] || seen[k]) continue;
      seen[r.id] = 1; seen[k] = 1;
      all.push(r);
    }
  }

  function when(r) { return r.created_at_platform || r.created_at || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function fmt(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function productOf(r) {
    var ids = r.external_unique_id || [];
    for (var i = 0; i < ids.length; i++) { if (PMAP[ids[i]]) return PMAP[ids[i]]; }
    return null;
  }

  function card(r) {
    var pct = Math.max(0, Math.min(100, (Number(r.rating) || 0) * 20));
    var p = productOf(r);
    var name = (r.reviewer && r.reviewer.display_name) ? r.reviewer.display_name : 'Verified customer';
    var verified = r.reviewer && r.reviewer.verified;
    var date = fmt(when(r));
    var tags = (r.tags || []).slice(0, 3);
    var h = '<li class="mlrv__card">';
    h += '<span class="mlrv-stars" style="--mlrv-p:' + pct + '%" role="img" aria-label="' + (Number(r.rating) || 0) + ' out of 5 stars">';
    h += '<span class="mlrv-stars__bg" aria-hidden="true">★★★★★</span>';
    h += '<span class="mlrv-stars__fg" aria-hidden="true">★★★★★</span></span>';
    h += '<blockquote class="mlrv__quote">' + esc(text(r)).replace(/\n/g, '<br>') + '</blockquote>';
    if (tags.length) {
      h += '<ul class="mlrv__tags">';
      for (var i = 0; i < tags.length; i++) h += '<li>' + esc(tags[i]) + '</li>';
      h += '</ul>';
    }
    if (p) h += '<a class="mlar__prod" href="' + esc(p.u) + '">' + esc(p.t) + '</a>';
    else if (r.is_business) h += '<span class="mlar__prod mlar__prod--store">Max &amp; Louie</span>';
    h += '<p class="mlrv__by"><span class="mlrv__name">' + esc(name) + '</span>';
    if (verified) h += '<span class="mlrv__verified">Verified</span>';
    if (date) h += '<span class="mlrv__date">' + date + '</span>';
    h += '</p></li>';
    return h;
  }

  function applyFilter() {
    view = all.filter(function (r) {
      if (filter === 'store') return !!r.is_business;
      if (filter === 'product') return !r.is_business;
      return true;
    });
    view.sort(function (a, b) { return String(when(b)).localeCompare(String(when(a))); });
    grid.innerHTML = '';
    shown = 0;
    renderMore();
    var avg = view.length ? (view.reduce(function (s, r) { return s + (Number(r.rating) || 0); }, 0) / view.length) : 0;
    if (summaryEl) {
      summaryEl.innerHTML = '<span class="mlrv__avg">' + avg.toFixed(1) + '</span>' +
        '<span class="mlrv-stars mlrv-stars--lg" style="--mlrv-p:' + (avg * 20) + '%">' +
        '<span class="mlrv-stars__bg" aria-hidden="true">★★★★★</span>' +
        '<span class="mlrv-stars__fg" aria-hidden="true">★★★★★</span></span>' +
        '<span class="mlrv__count">' + view.length + ' written review' + (view.length === 1 ? '' : 's') + '</span>';
    }
  }

  function renderMore() {
    var next = view.slice(shown, shown + PAGE);
    var html = '';
    for (var i = 0; i < next.length; i++) html += card(next[i]);
    grid.insertAdjacentHTML('beforeend', html);
    shown += next.length;
    if (moreBtn) moreBtn.hidden = shown >= view.length;
  }

  function runBatches(jobs, size) {
    var i = 0;
    function step() {
      if (i >= jobs.length) return Promise.resolve();
      var slice = jobs.slice(i, i + size);
      i += size;
      return Promise.all(slice.map(function (f) { return f(); })).then(step);
    }
    return step();
  }

  if (moreBtn) moreBtn.addEventListener('click', renderMore);
  for (var t = 0; t < tabs.length; t++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        filter = btn.getAttribute('data-tab');
        for (var k = 0; k < tabs.length; k++) tabs[k].classList.toggle('is-active', tabs[k] === btn);
        applyFilter();
      });
    })(tabs[t]);
  }

  if (statusEl) statusEl.textContent = 'Loading every review…';

  Promise.all([api({}), api({ is_business: 'true' })]).then(function (res) {
    add(res[0]); add(res[1]);
    applyFilter();
    var ids = Object.keys(PMAP);
    var jobs = ids.map(function (id) {
      return function () { return api({ external_unique_id: id }).then(function (list) { add(list); }); };
    });
    return runBatches(jobs, 5).then(function () {
      applyFilter();
      if (statusEl) statusEl.textContent = '';
    });
  }).catch(function () {
    if (statusEl) statusEl.textContent = '';
  });
})();